import members from "@/content/team.json";
import optimized from "@/content/optimized-images.json";

// Shared with the server resolver. Published slugs are stable identifiers.
export const teamMembers = members.map((member) => ({ ...member, img: optimized[member.img] || member.img }));
export const findTeamMember = (slug) => teamMembers.find((m) => m.slug === slug);
export const resolveTeamSlug = (value) => {
  const compact = String(value || '').replace(/[-_\s]+/g, '').toLowerCase();
  return teamMembers.find((m) => m.slug.replace(/-/g, '') === compact)?.slug;
};